export enum CreditCardType {
  AMERICAN_EXPRESS = 'AMERICAN_EXPRESS',
  MASTERCARD = 'MASTERCARD',
  VISA = 'VISA',
}

export enum FeeType {
  CORPORATE = 'Corporate',
}

export type CreditCardFeeMap = {
  [K in CreditCardType]: number;
};
